/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description abbreviateNumber
 */

// abbreviate large numbers. i.e 475,000 becomes 475K
const abbreviateNumber = (num: number): number | `${number}${'B' | 'M' | 'K'}` => {
  const abs = Math.abs(num)
  if (abs >= 1000000000) {
    return `${(num / 1000000000).toFixed(1).replace(/\.0$/, '') as `${number}`}B`
  }

  if (abs >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '') as `${number}`}M`
  }

  if (abs >= 10000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '') as `${number}`}K`
  }

  return num
}

export default abbreviateNumber
